import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { onKeyDown } from "../../../../../service";
import downloadIcon from '../../../../../assests/assessments/download.png';
import previewIcon from '../../../../../assests/assessments/preview.png';
import fileIcon from '../../../../../assests/assessments/file.png';
import classes from './AttachmentsPopup.module.css';
import useClickOutside from "../../../../../hooks/useClickOutside";


const AttachmentsPopup = ({ data,setShowAttachments }) => {

    const { texts } = useSelector(state => state.translate);

    const popupRef = useRef(null);

    useClickOutside(popupRef, () => {
        setShowAttachments(false);
    });

    const forceDownload = (blob, filename) => {
        var a = document.createElement('a');
        a.download = filename;
        a.href = blob;
        // For Firefox https://stackoverflow.com/a/32226068
        document.body.appendChild(a);
        a.click();
        a.remove();
    }

    // Current blob size limit is around 500MB for browsers
    const downloadResource = (e,a) => {
        e.stopPropagation();
        fetch(`${data.filesBaseUrl}/${a.FileSubUrl}`, {
            headers: new Headers({
                'Origin': window.location.origin
            }),
            mode: 'cors'
        }).then(response => response.blob())
            .then(blob => {
                let blobUrl = window.URL.createObjectURL(blob);
                forceDownload(blobUrl, a.Description);
            }).catch(e => console.error(e));
    }
    return (
        <div className={classes.AttachmentsPopup} ref={popupRef}>
            <div className={classes.Triangle}></div>
            <div className={classes.AttachmentsPopupContainer}>
                {data.contentData?.Attachments.length > 0 ?
                    <>
                        <div>{texts.attachmentFiles} ({data.contentData?.Attachments.length})</div>
                        {data.contentData?.Attachments?.map(a =>
                            <div key={a.Id} className={classes.AttachmentItem}>
                                <img className={classes.AttachmentImg} src={downloadIcon} alt="DownloadIcon" onClick={e => downloadResource(e,a)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => downloadResource(e,a))} />
                                <div className={classes.AttachmentName}>{a.Description}</div>
                                <img src={fileIcon} alt="FileIcon" />
                            </div>)}
                    </>
                    : <div>{texts.NoAttachments}</div>}
            </div>
        </div>
    )
}


export default AttachmentsPopup;